const en = {
  libraryTitle: "Drawings",
  backToEditor: "Last drawing",
  newDrawing: "New drawing",
  importFiles: "Import",
  search: "Search drawings…",
  sortUpdated: "Last modified",
  sortCreated: "Date created",
  sortName: "Name",
  allDrawings: "All drawings",
  trash: "Trash",
  selectAll: "Select all",
  selectedCount: "{count} selected",
  exportZip: "Download ZIP",
  includePng: "Include PNG",
  moveToTrash: "Move to trash",
  restore: "Restore",
  deleteForever: "Delete forever",
  open: "Open",
  rename: "Rename",
  duplicate: "Duplicate",
  download: "Download",
  delete: "Delete",
  cancel: "Cancel",
  close: "Close",
  save: "Save",
  confirm: "Confirm",
  copySuffix: "(copy)",
  untitled: "Untitled",
  emptyLibrary: "No drawings yet. Create a new one to get started.",
  emptyTrash: "The trash is empty.",
  noResults: "No drawings match your search.",
  currentDrawing: "Last opened",
  notSynced: "Not synced",
  elements: "{count} elements",
  renameTitle: "Rename drawing",
  drawingName: "Drawing name",
  confirmPurgeTitle: "Delete forever?",
  confirmPurge:
    "{count} drawing(s) will be permanently deleted on every device. This cannot be undone.",
  importFailed: "Could not import {name}: not a valid Excalidraw file.",
  exporting: "Preparing ZIP…",
  syncSynced: "Synced",
  syncSyncing: "Syncing…",
  syncOffline: "Offline",
  syncError: "Sync error",
  syncSignedOut: "Login required",
  syncSignIn: "Click to log in again (your changes are kept on this device)",
  syncPending: "{count} to sync",
  syncNow: "Sync now",
  lastSync: "Last sync: {time}",
  never: "never",
  drawingsLibrary: "Drawings library",
  renameCurrent: "Rename drawing",
  currentDrawingDeleted: "The drawing was deleted on another device",
  drawingUpdatedBy: "Drawing updated by {name}",
  drawingUpdated: "Drawing updated on another device",
  drawingNotFound: "Drawing not found",
  error: "Error",
  conflict: "Conflict",
  conflictsCount: "{count} in conflict",
  conflictTitle: "Conflicting changes",
  conflictDescription:
    "“{name}” was changed both on this device and on another one. Choose which version to keep: the version being replaced stays available in the version history.",
  thisDevice: "This device",
  otherDevice: "Other device",
  unknownDevice: "unknown device",
  keepMine: "Keep mine",
  keepMineHint: "Overwrite the other device's changes",
  useTheirs: "Use theirs",
  useTheirsHint: "Discard the changes made on this device",
  mergeBoth: "Merge",
  mergeBothHint: "Combine the changes of both versions",
  keepBoth: "Keep both",
  keepBothHint: "Save this device's version as a separate copy",
  decideLater: "Decide later",
  conflictCopyName: "copy from {device}, {date}",
  conflictResolved: "Conflict resolved",
  versionHistory: "Version history",
  currentVersion: "Current",
  restoreVersion: "Restore",
  restoreConfirm:
    "Restore the version of {date}? The current content will be kept in the history.",
  versionRestored: "Version restored",
  historyOffline: "The version history is on the server: connect to view it.",
  historyEmpty: "No previous versions yet.",
  historyHint:
    "A version is kept every 10 minutes of editing, and whenever another device or a conflict resolution overwrites the drawing.",
  loading: "Loading…",
  settings: "Settings",
  logOut: "Log out ({user})",
  deviceName: "Name of this device",
  deviceNameHint:
    "Shown to other devices in conflicts and in the version history.",
  conflictModeLabel: "When a drawing was changed on two devices",
  conflictModeAsk: "Ask me what to do",
  conflictModeMerge: "Always merge automatically",
  newFolder: "New folder",
  newFolderName: "New folder",
  folderName: "Folder name",
  renameFolderTitle: "Rename folder",
  rootFolder: "Drawings",
  moveTo: "Move to…",
  move: "Move",
  folderSummary: "{drawings} drawings · {folders} folders",
  emptyFolder:
    "This folder is empty. Create a drawing here or drag drawings onto it.",
  folderNotFound: "Folder not found (maybe not synced yet).",
  deleteFolderTitle: "Delete folder",
  deleteEmptyFolder: "Delete {names}?",
  deleteFolderContents:
    "{names} contains {drawings} drawing(s) and {folders} sub-folder(s). What should happen to them?",
  deleteFolderKeep: "Move the contents to “{parent}”",
  deleteFolderKeepHint: "Only the folder is deleted",
  deleteFolderAll: "Delete everything",
  deleteFolderAllHint: "Drawings go to the trash, sub-folders are deleted",
  parentFolders: "their parent folders",
};

type Dictionary = typeof en;

const it: Dictionary = {
  libraryTitle: "Disegni",
  backToEditor: "Ultimo disegno",
  newDrawing: "Nuovo disegno",
  importFiles: "Importa",
  search: "Cerca disegni…",
  sortUpdated: "Ultima modifica",
  sortCreated: "Data di creazione",
  sortName: "Nome",
  allDrawings: "Tutti i disegni",
  trash: "Cestino",
  selectAll: "Seleziona tutti",
  selectedCount: "{count} selezionati",
  exportZip: "Scarica ZIP",
  includePng: "Includi PNG",
  moveToTrash: "Sposta nel cestino",
  restore: "Ripristina",
  deleteForever: "Elimina definitivamente",
  open: "Apri",
  rename: "Rinomina",
  duplicate: "Duplica",
  download: "Scarica",
  delete: "Elimina",
  cancel: "Annulla",
  close: "Chiudi",
  save: "Salva",
  confirm: "Conferma",
  copySuffix: "(copia)",
  untitled: "Senza titolo",
  emptyLibrary: "Nessun disegno. Creane uno nuovo per iniziare.",
  emptyTrash: "Il cestino è vuoto.",
  noResults: "Nessun disegno corrisponde alla ricerca.",
  currentDrawing: "Ultimo aperto",
  notSynced: "Non sincronizzato",
  elements: "{count} elementi",
  renameTitle: "Rinomina disegno",
  drawingName: "Nome del disegno",
  confirmPurgeTitle: "Eliminare definitivamente?",
  confirmPurge:
    "{count} disegno/i verranno eliminati definitivamente su tutti i dispositivi. L'operazione non è reversibile.",
  importFailed:
    "Impossibile importare {name}: non è un file Excalidraw valido.",
  exporting: "Preparazione ZIP…",
  syncSynced: "Sincronizzato",
  syncSyncing: "Sincronizzazione…",
  syncOffline: "Offline",
  syncError: "Errore di sincronizzazione",
  syncSignedOut: "Accesso richiesto",
  syncSignIn: "Clicca per accedere di nuovo (le modifiche restano su questo dispositivo)",
  syncPending: "{count} da sincronizzare",
  syncNow: "Sincronizza ora",
  lastSync: "Ultima sincronizzazione: {time}",
  never: "mai",
  drawingsLibrary: "Libreria disegni",
  renameCurrent: "Rinomina disegno",
  currentDrawingDeleted: "Il disegno è stato eliminato su un altro dispositivo",
  drawingUpdatedBy: "Disegno aggiornato da {name}",
  drawingUpdated: "Disegno aggiornato su un altro dispositivo",
  drawingNotFound: "Disegno non trovato",
  error: "Errore",
  conflict: "Conflitto",
  conflictsCount: "{count} in conflitto",
  conflictTitle: "Modifiche in conflitto",
  conflictDescription:
    "“{name}” è stato modificato sia su questo dispositivo sia su un altro. Scegli quale versione tenere: quella sostituita resta comunque disponibile nella cronologia versioni.",
  thisDevice: "Questo dispositivo",
  otherDevice: "Altro dispositivo",
  unknownDevice: "dispositivo sconosciuto",
  keepMine: "Mantieni la mia",
  keepMineHint: "Sovrascrive le modifiche dell'altro dispositivo",
  useTheirs: "Usa la loro",
  useTheirsHint: "Scarta le modifiche fatte su questo dispositivo",
  mergeBoth: "Unisci",
  mergeBothHint: "Combina le modifiche di entrambe le versioni",
  keepBoth: "Mantieni entrambe",
  keepBothHint: "Salva la versione di questo dispositivo come copia separata",
  decideLater: "Decidi dopo",
  conflictCopyName: "copia da {device}, {date}",
  conflictResolved: "Conflitto risolto",
  versionHistory: "Cronologia versioni",
  currentVersion: "Attuale",
  restoreVersion: "Ripristina",
  restoreConfirm:
    "Ripristinare la versione del {date}? Il contenuto attuale resterà nella cronologia.",
  versionRestored: "Versione ripristinata",
  historyOffline:
    "La cronologia versioni è sul server: connettiti per consultarla.",
  historyEmpty: "Non ci sono ancora versioni precedenti.",
  historyHint:
    "Viene conservata una versione ogni 10 minuti di modifiche, e ogni volta che un altro dispositivo o la risoluzione di un conflitto sovrascrive il disegno.",
  loading: "Caricamento…",
  settings: "Impostazioni",
  logOut: "Esci ({user})",
  deviceName: "Nome di questo dispositivo",
  deviceNameHint:
    "Viene mostrato agli altri dispositivi nei conflitti e nella cronologia versioni.",
  conflictModeLabel: "Quando un disegno è stato modificato su due dispositivi",
  conflictModeAsk: "Chiedimi cosa fare",
  conflictModeMerge: "Unisci sempre automaticamente",
  newFolder: "Nuova cartella",
  newFolderName: "Nuova cartella",
  folderName: "Nome della cartella",
  renameFolderTitle: "Rinomina cartella",
  rootFolder: "Disegni",
  moveTo: "Sposta in…",
  move: "Sposta",
  folderSummary: "{drawings} disegni · {folders} cartelle",
  emptyFolder:
    "Questa cartella è vuota. Crea un disegno qui o trascinaci dei disegni.",
  folderNotFound: "Cartella non trovata (forse non ancora sincronizzata).",
  deleteFolderTitle: "Elimina cartella",
  deleteEmptyFolder: "Eliminare {names}?",
  deleteFolderContents:
    "{names} contiene {drawings} disegno/i e {folders} sottocartella/e. Cosa vuoi farne?",
  deleteFolderKeep: "Sposta il contenuto in «{parent}»",
  deleteFolderKeepHint: "Viene eliminata solo la cartella",
  deleteFolderAll: "Elimina tutto",
  deleteFolderAllHint:
    "I disegni finiscono nel cestino, le sottocartelle vengono eliminate",
  parentFolders: "nelle rispettive cartelle superiori",
};

const getLanguage = () => {
  try {
    return localStorage.getItem("i18nextLng") || navigator.language || "en";
  } catch {
    return navigator.language || "en";
  }
};

export const libraryLocale = getLanguage();

const dictionary: Dictionary = libraryLocale.toLowerCase().startsWith("it")
  ? it
  : en;

export const lt = (
  key: keyof Dictionary,
  vars?: Record<string, string | number>,
) =>
  dictionary[key].replace(/\{(\w+)\}/g, (match, name) =>
    vars && name in vars ? String(vars[name]) : match,
  );

export const formatDateTime = (timestamp: number) =>
  new Date(timestamp).toLocaleString(libraryLocale, {
    dateStyle: "medium",
    timeStyle: "short",
  });

export const formatShortDateTime = (timestamp: number) =>
  new Date(timestamp).toLocaleString(libraryLocale, {
    dateStyle: "short",
    timeStyle: "short",
  });
